<!--
 * @Author: Q in 
 * @Date: 2026-03-10 09:45:40
 * @LastEditors: Q in 
 * @LastEditTime: 2026-04-25 10:39:14
 * @FilePath: /new_kefu_pc/src/App-admin.vue
 * @Description: 客服端根组件
-->
<template>
	<div id="admin-container">
		<router-view />
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	components: {},

	mounted() {},

	methods: {}
};
</script>

<style scoped lang="scss"></style>
